import React, { useEffect, useState, useContext } from "react";

import PageHeader from "../pageheader/PageHeader";
import HeadBar from "./headBar/HeadBar";
import Map from "../material/map/Map";
import styles from "./Contact.module.css";
import Button from "../material/button/Button";
// import Footer from './footer/Footer'
import Breadcrumb from "./breacrumb/breadcrumb";
import * as publicApi from "../../service/publicApi";
import { CurrentUserContext } from "../../App";

function Contact({ disabledMenu }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  const [latitude, setLatitude] = useState(13.853135);
  const [longitude, setLongitude] = useState(100.531792);
  const [contact, setContact] = useState([
    { name: "นางสาวพรนภัส อยู่นุช", email: "pornnapat.y@dmsc.mail.go.th" },
  ]);

  useEffect(() => {
    getContact();
  }, []);

  const onClickButton = () => {
    window.open(
      `https://maps.google.com/?q=${latitude},${longitude}`,
      "_system",
    );
  };
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ติดต่อเรา", url: "/" },
  ];

  const getContact = async () => {
    let page = 1;
    let number_per_page = 4;
    const res = await publicApi.getContact(page, number_per_page);
    if (res) {
      if (res["data"]["code"] === 200) {
        setContact(res["data"]["contact_list"]);
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }
  };

  return (
    <>
      <div className="global-page">
        {
          // disabledMenu ? null : <HeadBar menu={'contact'} />
        }
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={"ติดต่อเรา"} />

        <div className={styles.title}>
          <div className={styles.subTitle}>
            สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
          </div>
          <div>
            88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ อ.เมือง จ.นนทบุรี 11000
          </div>
          <div>
            Department of Medical Sciences, Ministry of Public Health, Tivanond
            Road Nonthaburi 11000, Thailand
          </div>
          <div>โทรศัพท์. 0-2589-9850 ถึง 8 ต่อ 98096</div>
          <div className="m-8 md:m-2">
            ศูนย์เทคโนโลยีสารสนเทศ กรมวิทยาศาสตร์การแพทย์ E-mail :
            itc.all@dmsc.mail.go.th
          </div>
        </div>

        <div className={styles.button}>
          <div className="w-[600px]">
            <Button
              onClick={() => {
                onClickButton();
              }}
              className=""
            >
              ขอเส้นทาง
            </Button>
          </div>
        </div>

        <div className="flex justify-center my-[14px]">
          <div style={{ width: 1000, height: 500 }}>
            <Map
              disabled={true}
              latitude={latitude}
              longitude={longitude}
              nameLab={
                "88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ อ.เมือง จ.นนทบุรี 11000"
              }
              onChange={(e) => {
                // console.log(e)
              }}
            />
          </div>
        </div>

        <div className="flex justify-center underline m-[20px] text-[20px] sm:text-[12px]">
          หรือติดต่อได้ที่
        </div>
        <div className="flex flex-row sm:flex-row gap-2 justify-center items-center text-[16px] sm:text-[12px] text-center sm:text-left">
          <div className="font-bold">Line Phukphan official:</div>
          <span>@445xfhbj</span>
        </div>
        <div className="flex flex-row sm:flex-row gap-2 justify-center items-center text-[16px] sm:text-[12px] text-center sm:text-left">
          <div className="font-bold">และ Email:</div>
          <span>phukphan@dmsc.mail.go.th</span>
        </div>

        <div className="flex gap-x-12 justify-center lg:grid md:gap-x-2 lg:grid-cols-2 md:!grid-cols-1 md:text-xs lg:gap-4 py-2">
          {contact ? (
            <>
              {contact.map((item, index) => (
                <div
                  key={index}
                  className="grid basis-1 md:justify-items-center"
                >
                  <div className="font-bold text-nowrap">
                    {item.prefix} {item.firstName} {item.lastName}
                  </div>
                  <div>{item.email}</div>
                </div>
              ))}
            </>
          ) : null}
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default Contact;
